import { useState, useEffect } from 'react'

import TeamCard from './TeamCard'
import LoadingScreen from '../utils/LoadingScreen';

import '../../stylesheets/team.css'

import { dbRef } from '../../config/firebase'
import { get, child } from "firebase/database";

const Team = (props) => {
	useEffect(() => {
		props.setOnPage(3)
	}, [props])

	const [isCore, setIsCore] = useState(true);

	const [coreData, setCoreData] = useState([])
	const [coComData, setCoComData] = useState([])
	const [data, setData] = useState([]);

	useEffect(() => {
		async function fetchCoreData() {
			await get(child(dbRef, 'coreCom/')).then((snapshot) => {
				if (!snapshot.exists()) {
					console.log("No Core data available")
				}
				setCoreData(snapshot.val() ?? [])
			})
		}
		async function fetchCoComData() {
			await get(child(dbRef, 'coCom/')).then((snapshot) => {
				if (!snapshot.exists()) {
					console.log("No Co-Com data available")
				}
				setCoComData(snapshot.val() ?? [])
			})
		}

		fetchCoreData();
		fetchCoComData();
	}, [])

	useEffect(() => {
		setData(isCore ? coreData : coComData)
	}, [isCore, coreData, coComData])

	return (
		<div id="team">
			<div className='flex flex-center gap-3'>
				<button
					className={`team-button${isCore ? ' selected-bttn' : ''}`}
					onClick={() => setIsCore(true)}
				>
					Core Committee
				</button>

				<button
					className={`team-button${!isCore ? ' selected-bttn' : ''}`}
					onClick={() => setIsCore(false)}
				>
					Co Committee
				</button>
			</div>
			<div className="teams-title">
				<p className='cool-looking-underline'>
					Our Team
				</p>
			</div>
			<div className="teams-wrapper flex">
				{
					data?.length
						?
						data.map((member, idx) => {
							return (
								<TeamCard key={idx} member={member} />
							)
						})
						:
						isCore ? <LoadingScreen /> : <h2>Coming Soon...</h2>
				}
			</div>
		</div>
	)
}

export default Team